// extracted by mini-css-extract-plugin
export default {"cls1":"ImpactHubProfileCard-cls1___d8c59094ba066568f0b","cls2":"ImpactHubProfileCard-cls2___285229879dbbe29722a ImpactHubProfileCard-cls1___d8c59094ba066568f0b"};